import React from "react";
import Button from "@material-ui/core/Button";
import { InputAdornment } from "@material-ui/core";
import Add from '@material-ui/icons/Add';

import FormHeader from "../../components/shared/form/formHeader";
import FormulariosList from "../../components/shared/formulario/formulariosList";

const Formularios = (props) => {
  const { history } = props;

  const ActionButton = () => (
    <Button variant="contained" onClick={() => history.push("/formulario")}>
      <InputAdornment position="start">
        <Add style={{ cursor: "pointer" }} />
      </InputAdornment>
      Criar novo
    </Button>
  );

  return (
    <div>
      <FormHeader ActionButton={ActionButton} titulo="Formulários" />
      <FormulariosList history={history} marginTop={100} 
      mostrarSomenteAtivos={false}
      />
    </div>
  );
};

export default Formularios;
